module.exports = __webpack_public_path__ + "media/fonts/OpenSans-BoldItalic-509f36f6029476925dfd2a78688c06dd.ttf";